var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',_vm._l((_vm.actions),function(action,key){return _c('v-list-tile',{key:key,staticClass:"action-item",on:{"click":function($event){return _vm.getList(key)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(action.title))])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }